import { useQuery } from '@tanstack/react-query';
import { useDemo } from '../../../demo/DemoContext';
import { useWorkspace } from '../../stores';
import { customersApi } from '../api/customersApi';
export function useCustomers() {
  const { isDemo, store, scopeKey } = useWorkspace();
  const demo = useDemo();
  return useQuery({ queryKey: [...scopeKey, 'customers', isDemo ? demo.revision : 0], queryFn: ({ signal }) => isDemo ? Promise.resolve(demo.customers.filter(c => c.store_id === store?.id)) : customersApi.list(signal), enabled: Boolean(store?.id), staleTime: 30_000 });
}
